import { Injectable } from "@angular/core";

type DisplayDescription = stages.core.DisplayDescription;
type EditorConfig = stages.context.EditorConfig;

interface DescriptionAndEditorConfig {
	description: DisplayDescription;
	editorConfig: EditorConfig;
}

@Injectable({ providedIn: "root" })
export class EditorToDisplayDescriptionMap {
	private map = new Map<string, DescriptionAndEditorConfig>();

	set(
		editorId: string,
		beanType: string,
		beanId: string,
		descriptionAndEditorConfig: DescriptionAndEditorConfig,
	): void {
		this.map.set(getEditorKey(editorId, beanType, beanId), descriptionAndEditorConfig);
	}

	get(editorId: string, beanType: string, beanId: string): DescriptionAndEditorConfig | undefined {
		const editorKey = getEditorKey(editorId, beanType, beanId);
		return this.map.get(editorKey);
	}

	delete(editorId: string, beanType: string, beanId: string): void {
		this.map.delete(getEditorKey(editorId, beanType, beanId));
	}

	clear(): void {
		this.map.clear();
	}
}

function getEditorKey(editorId: string, beanType: string, beanId: string): string {
	return `${editorId}//${beanType}//${beanId}`;
}
